import React from "react";
import { Navigate } from "react-router-dom";
import Sidebar from "./components/common/Sidebar";
import MainIndex from "./screens/MainIndex";

const ProtectedRoute = () => {
  const activekey = () => {
    let res = window.location.pathname;
    let baseUrl = process.env.PUBLIC_URL;
    baseUrl = baseUrl.split("/");
    res = res.split("/");
    res = res.length > 0 ? res[baseUrl.length] : "/";
    res = res ? "/" + res : "/";
    const activeKey1 = res;
    return activeKey1;
  };

  if (!localStorage.getItem("token")) {
    return <Navigate to={`/sign-in/`} replace />;
  }

  return (
    <div id="ebazar-layout" className="theme-blue">
      <Sidebar activekey={activekey()} />
      <MainIndex />
    </div>
  );
};

export default ProtectedRoute;
